import { Modal } from 'antd';
import styled from 'styled-components';

import { media } from '@/shared/components';
import { COLORS } from '@/shared/constants/colors';

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: start;
  padding-top: 24px;
  padding-inline: 24px 10%;
  height: 90px;
  color: ${COLORS.white};

  .second-side {
    display: flex;
    gap: 24px;
  }

  .icon-text {
    ${media.md} {
      display: none;
    }

    ${media.sm} {
      display: none;
    }
  }
`;

export const IconWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;

  .icon-text {
    font-size: 14px;
    font-weight: bold;
  }
`;

export const ImageWrap = styled.div`
  height: 710px;

  display: flex;
  flex: 0;

  ${media.md} {
    flex: 1;
  }

  ${media.sm} {
    flex: 1;
  }
`;

export const StyledModal = styled(Modal)`
  &&& {
    .ant-modal-content {
      padding: 0;
      border-radius: 12px;
      overflow: hidden;
    }

    .ant-modal-body {
      height: 800px;
      background: ${COLORS.colorFilePreviewBg};
    }

    .ant-modal-close {
      background: ${COLORS.systemLight200};
      border-radius: 50%;
      top: 24px;
      right: 24px;
      width: 24px;
      height: 24px;
    }

    ${media.md} {
      top: 0;
      height: 100%;
      max-width: 100%;
      padding: 0;
      margin: 0;
      border-radius: 0;

      .ant-modal-content {
        border-radius: 0;
      }

      .ant-modal-close {
        display: none;
      }

      & > div,
      .ant-modal-body,
      .ant-modal-content {
        height: 100%;
      }
    }

    ${media.sm} {
      top: 0;
      height: 100%;
      max-width: 100%;
      padding: 0;
      margin: 0;
      border-radius: 0;

      .ant-modal-content {
        border-radius: 0;
      }

      .ant-modal-close {
        display: none;
      }

      & > div,
      .ant-modal-body,
      .ant-modal-content {
        height: 100%;
      }
    }
  }
`;
